module.exports = __webpack_public_path__ + "fonts/fx-logo.svg";